import { Menu, MenuItem } from "@mui/material";
import ValidateAccess from "components/ValidateAccess";
import { Permissions } from "data/permissons";
import { AccountMenuProps } from "layout/primarylayout/AccountMenu";
import { useState } from "react";
import EditCategory from "./EditCategory";
import { deleteCategory } from "api/services/categories";
import { useMutation, useQueryClient } from "react-query";
import { snack } from "components/toast";
import { useConfirm } from "context/ConfirmDialog";

interface EditCategoryPopoverProps extends AccountMenuProps {
  data: any;
}

function EditCategoryPopover(props: EditCategoryPopoverProps) {
  const { anchorEl, setAnchorEl, data } = props;
  const [editOpen, setEditOpen] = useState<boolean>(false);
  const open = Boolean(anchorEl);
  const queryClient = useQueryClient();
  const confirm = useConfirm();

  const handleEdit = () => {
    setEditOpen(true);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const { mutate } = useMutation(deleteCategory, {
    onSuccess: () => {
      snack.success("Category Deleted");
      queryClient.invalidateQueries("categories");
    },
    onError: (err: any) => {
      snack.error(err.response.data.message);
    },
  });

  const handleDelete = () => {
    confirm({
      msg: "Are you sure you want to delete this category?",
      action: () => mutate({ id: data?.id }),
    });
  };

  return (
    <>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            minWidth: 100,
          },
        }}
      >
        <ValidateAccess name={Permissions.EDIT_CATEGORIES}>
          <MenuItem onClick={handleEdit}>Edit</MenuItem>
        </ValidateAccess>
        <ValidateAccess name={Permissions.DELETE_CATEGORIES}>
          <MenuItem onClick={handleDelete}>Delete</MenuItem>
        </ValidateAccess>
      </Menu>
      <EditCategory open={editOpen} setOpen={setEditOpen} data={data} />
    </>
  );
}

export default EditCategoryPopover;
